<template>
  <div class="player-container">
    <div class="countdown" v-if="liveStatus == 0">
      距直播开始还有 <span>{{ countdown.days }}</span>天<span>{{ countdown.hours }}</span>时<span>{{ countdown.mins
      }}</span>分<span>{{ countdown.seconds }}</span>秒
    </div>
    <div class="liveEnd" v-if="liveStatus == 2">
      <!-- 直播已结束<br> -->
      点击日程查看精彩回放
    </div>
    <div class="bg_cover" id="test" v-if="liveDetails != {} && liveDetails.banner_type == 2 && showPoster">
      <img :src="liveDetails.banner" alt="">
      <ul>
        <!-- <p :style="{ 'color': liveDetails.schedule_font_color_hex ? liveDetails.schedule_font_color_hex : '#fff' }">{{
          liveDetails.time }}{{ liveDetails.name }}{{ liveDetails.hall_name ? '(' + liveDetails.hall_name + ')' : '' }}
        </p> -->
        <li v-for="ct in recordedList"
          :style="{ 'color': liveDetails.schedule_font_color_hex ? liveDetails.schedule_font_color_hex : '#fff' }"
          :key="ct.id">
          <span
            :style="{ 'background-color': liveDetails.schedule_font_color_hex ? liveDetails.schedule_font_color_hex : '#fff' }"></span>
          {{ ct.name }}
        </li>
        <div class="player-icon" @click="getLiveInfo(liveDetails, 'play')">
          <van-icon name="play" />
        </div>

      </ul>
    </div>
    <video-player class="vjs-custom-skin" @timeupdate="onPlayerTimeupdate" @canplay="onPlayerPlay" @ended="onPlayerEnd" @pause="onPlayerPause"
      :options="playerOptions" @play="onVideoPlay" ref="videoPlayer" :playsinline="playsinline"></video-player>
    <!-- 字幕 -->
    <div class="zimu" v-if="show_zimu_player && isPlaying && liveStatus == 1 && connectWebSocketStatus">
      <span class="textBox">{{ displayText }}</span>
    </div>
  </div>
</template>

<script>
//引入video样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
//引入hls.js
import 'videojs-contrib-hls.js/src/videojs.hlsjs'
import $ from 'jquery'
// import html2Canvas from 'html2canvas'
let codeTimer;   //定时器
let textTimer;
let delayTimer;
import { Icon } from 'vant';
import { LiveVideoSubtitle } from '../../config/interface'
export default {
  props: ['zimuInfo', "lang", 'show_zimu_player','show_zimu_tab', 'session_id'],
  components: {
    Icon
  },
  data() {
    return {
      liveStatus: 1,       //直播状态  0:未开始   1:进行中  2:已结束   3:播放录播默认进行中
      liveDetails: {},       //直播详情
      video_url: this.$store.state.videoUrl,
      playerOptions: {},   //直播视频配置
      liveStartTime: null,  //直播开始时间戳
      liveEndTime: null,    //直播结束时间戳
      currentTime: null,   //当前时间戳
      dValue: null,      //距直播开始时间
      // showCountFlag:false,   //展示倒计时
      newRecordedList: [],
      recordedList: [],
      countdown: {
        days: 0,
        hours: 0,
        mins: 0,
        seconds: 0
      },
      showPoster: false,
      zimuList: [],
      currentSubtitle: '',
      isSubtitleActive: '',
      displayText: '', // 用于逐字显示的文本
      animationInterval: null, // 动画定时器
      subtitles: [], // 存储字幕数据，
      wsConnection: null, // WebSocket连接实例
      maxReconnectAttempts: 15, // 最大重连次数
      currentSegmentIndex: 0, // 当前显示的字幕段索引
      segmentDisplayTimer: null, // 分段显示定时器
      connectWebSocketStatus: false,
      timeout_count: 0,
      displayTextLine: 0,
      isPlaying: false,
    }
  },
  computed: {
    playsinline() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false
      } else {
        //ios端
        return true
      }
    }

  },
  watch: {
    '$store.state.videoUrl'(newData, oldData) {
      if (newData && this.playerOptions && this.playerOptions.sources && this.playerOptions.sources.length > 0) {
        this.playerOptions.sources[0].type = 'video/mp4';
        this.playerOptions.sources[0].src = newData;
        this.playerOptions.notSupportedMessage = '播放结束';
        this.liveStatus = 3;
      }
    },
    '$store.state.recording'(newData, oldData) {
      this.handleSchedule();
    },
    zimuInfo(newData, oldData) {
      if (newData) {
        this.zimuList = newData;
      }
    }
  },
  mounted() {

  },
  beforeDestroy() {
    this.clearCodeTimer();
    if (this.wsConnection) {
      this.wsConnection.close();
    }
  },
  methods: {
    connectWebSocket() {
      if (this.wsConnection && this.wsConnection.readyState === WebSocket.OPEN) {
        return;
      }
      this.wsConnection = new WebSocket(`wss://xgzxws.talkmed.com?session_id=${this.session_id}`);

      this.wsConnection.onopen = () => {
        console.log('WebSocket Connected');
      };
      this.wsConnection.onmessage = event => {
        try {
          this.websocketonmessage(event);
        } catch (e) {
          console.error('WebSocket message parse error:', e);
        }
      };
      this.wsConnection.onerror = () => {
        if (this.timeout_count < 5) {
          this.timeout_count++;
          console.log("连接失败，等待15s尝试重连" + this.timeout_count);
          setTimeout(() => {
            this.websocketonerror();
          }, 15000);
        }
      };
      this.wsConnection.onclose = () => {
        console.log('WebSocket Closed');
        this.websocketClose();
      };
    },
    //连接建立失败重连
    websocketonerror() {
      this.connectWebSocketStatus=false;
      this.connectWebSocket();
    },
    //关闭websocket尝试重连
    websocketClose() {
     this.connectWebSocketStatus=false;
     if (this.wsConnection) {
      this.wsConnection.close();
    }
      // this.connectWebSocket()
      
    },
    websocketonmessage(res) {
      var data = JSON.parse(res.data);
      if (data && data.type == 'mid_realtime_subtitle') {
        delayTimer = setTimeout(() => {
          this.connectWebSocketStatus = true; 
          this.processSubtitleData(data.data);
        }, 10000);
        return;

      }
    },

    processSubtitleData(info) {
      this.displayText = this.displayText + info.text + info.punc
      if (this.displayText.length > 110) {
        this.displayText = '';
      }
      this.displayTextLine = info.index
      this.$emit('updateZimu', info)

    },
    onVideoPlay() {
      // 用户点击播放后取消静音
      const player = this.$refs.videoPlayer && this.$refs.videoPlayer.player;
      if (player) {
        player.muted(false);
      }
      if (this.liveDetails.banner_type == 2) {
        this.showPoster = false
      }
      //直播字幕
      if (this.liveStatus == 1 && (this.show_zimu_player || this.show_zimu_tab)) {
        this.connectWebSocket();
        this.isPlaying = true
      }
    },
    onPlayerPause(){
      console.log('onPlayerPause')
      if (this.wsConnection) {
      this.wsConnection.close();
    }
      this.isPlaying = false
      this.connectWebSocketStatus=false
      this.displayText = ''
    },
    //直播信息
    getLiveInfo(data, name = null) {
      console.log(data.play_url_m3u8)
      this.liveDetails = data;
      if (this.liveDetails.banner_type == 2) {
        this.showPoster = true;
      }

      this.playerOptions = {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        controls: true, //控制条
        preload: 'auto', //视频预加载
        muted: false, //默认情况下将会消除任何音频。
        loop: false, //视频一结束就重新开始。
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'application/x-mpegURL',
          src: ''
        }],
        poster: data.banner, //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '直播已结束' //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      }
      if (name == 'play') {
        this.showPoster = false;
      }
      let arr1 = data.start_at.split(/[- : /]/);
      console.log(arr1);
      this.liveStartTime = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]).getTime();
      let arr2 = data.end_at.split(/[- : /]/);
      this.liveEndTime = new Date(arr2[0], arr2[1] - 1, arr2[2], arr2[3], arr2[4], arr2[5]).getTime();
      this.currentTime = new Date().getTime();
      console.log(this.currentTime, this.liveStartTime)
      if (this.$store.state.videoUrl) {

        console.log('直播中')
        //录播
        this.playerOptions.sources[0].type = 'video/mp4';
        this.playerOptions.sources[0].src = this.$store.state.videoUrl;
        if (name == 'play') {
          this.tryAutoPlay();
        }
      } else {
        //直播
        this.playerOptions.sources[0].type = 'application/x-mpegURL';
        if (this.currentTime > this.liveEndTime) {
          this.playerOptions.notSupportedMessage = '直播已結束';
          this.playerOptions.sources[0].src = null;
          this.liveStatus = 2;
        } else if (this.currentTime < this.liveStartTime) {
          this.playerOptions.sources[0].src = null;
          this.playerOptions.notSupportedMessage = '直播未开始';
          this.handleDate();
          this.liveStatus = 0;
          this.timeKeeper();
        } else {
          this.liveStatus = 1;
          this.playerOptions.sources[0].src = data.play_url_m3u8;
          this.playerOptions.notSupportedMessage = '无法播放';
          // 直播中打开页面自动播放
          this.showPoster = false;
          this.tryAutoPlay();
        }
      }
    },
    // 自动播放；失败时保持非静音暂停，等用户点击播放
    tryAutoPlay() {
      this.$nextTick(() => {
        setTimeout(() => {
          const player = this.$refs.videoPlayer && this.$refs.videoPlayer.player;
          if (!player) return;
          // player.muted(false);
          const playPromise = player.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              player.muted(true);
              player.play().then(() => {
                player.muted(false);
              }).catch(() => {});
            });
          }
        }, 300);
      });
    },

    //处理日程格式
    handleSchedule() {
      let recordedList = this.$store.state.recording[Object.keys(this.$store.state.recording)[0]];
      this.recordedList = recordedList
      console.log(recordedList)
      recordedList.forEach((item, index) => {
        item.details.forEach((val, ind) => {
          this.newRecordedList.push(item.details[ind].recordid)
        })
      })
    },
    //处理日期格式
    handleDate() {
      // 获取当前北京时间（东八区）（保证同一时区）
      let offset = 8 * 60; // 8小时对应分钟数
      let now = new Date();
      let utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      let beijingTime = new Date(utc + offset * 60000);
      let currentTime = beijingTime.getTime();
      this.dValue = this.liveStartTime - currentTime;
      let dValue = this.dValue;
      this.countdown.days = parseInt(dValue / (1000 * 60 * 60 * 24));
      this.countdown.hours = parseInt((dValue % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.countdown.hours = this.countdown.hours < 10 ? '0' + this.countdown.hours : this.countdown.hours;
      this.countdown.mins = parseInt((dValue % (1000 * 60 * 60 * 24)) % (1000 * 60 * 60) / (1000 * 60));
      this.countdown.mins = this.countdown.mins < 10 ? '0' + this.countdown.mins : this.countdown.mins;
      this.countdown.seconds = parseInt((dValue % (1000 * 60 * 60 * 24)) % (1000 * 60 * 60) % (1000 * 60) / 1000);
      this.countdown.seconds = this.countdown.seconds < 10 ? '0' + this.countdown.seconds : this.countdown.seconds;

    },
    //到计时
    timeKeeper() {
      if (this.dValue < 1000) {
        this.liveStatus = 1;
        window.location.reload();
        this.clearCodeTimer();

      } else {
        codeTimer = setTimeout(() => {
          this.handleDate();
          this.timeKeeper()
        }, 1000)
      }
    },
    //清除定时器
    clearCodeTimer() {
      clearTimeout(codeTimer);
      clearInterval(textTimer);
      clearTimeout(delayTimer);
    },

    //直播视频字幕  
    refreshLiveVideoZimu() {
      const url = LiveVideoSubtitle;
      let params = {
        id: this.session_id
      };
      const method = "Get";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          if (data) {
            this.startTextAnimation(data.content);
            this.$emit('updateZimu', data)
          }
        }
      });
    },
    // 时间更新处理
    onPlayerTimeupdate() {
      if (!this.show_zimu_player) return;
      // let currentTime = this.$refs.videoPlayer.player.currentTime; // 获取当前时间
      //录播时字幕
      // if (this.zimuList.length > 0 && this.show_zimu_player && this.liveStatus != 1) {
      //   console.log(`当前视频时间：${currentTime} 秒`,);
      //   // 查找当前字幕
      //   const activeSubtitle = this.zimuList.find(sub =>
      //     currentTime >= sub.start_at && currentTime <= sub.end_at
      //   );
      //   // 更新字幕状态
      //   if (activeSubtitle) {
      //     this.currentSubtitle = activeSubtitle.content;
      //     this.isSubtitleActive = true;
      //   } else {
      //     this.currentSubtitle = null;
      //     this.isSubtitleActive = false;
      //   }
      // }

    },
  
    //解决自动全屏
    onPlayerPlay() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        $('body').find('video').attr('x-webkit-airplay', true).attr('x5-playsinline', true).attr('webkit-playsinline', true).attr('playsinline', true).attr('x5-video-player-type', 'h5-page')
      } else {
        //ios端
        $('body').find('video').attr('webkit-playsinline', "true").attr('playsinline', "true").attr('x5-video-player-type', 'h5-page');

      }
    },
    //视频播放结束   自动播放下一个
    onPlayerEnd() {
      let newRecordedList = this.newRecordedList;
      let videoUrl = this.$store.state.videoUrl;
      newRecordedList.forEach((item, suffix) => {
        if (item == videoUrl && item != '') {
          this.playerOptions.sources[0].type = 'video/mp4';
          if (suffix == newRecordedList.length - 1) {
            this.playerOptions.sources[0].src = newRecordedList[0];
            this.$store.dispatch('receiveVideoUrl', newRecordedList[0]);
          } else {
            this.playerOptions.sources[0].src = newRecordedList[suffix + 1];
            this.$store.dispatch('receiveVideoUrl', newRecordedList[suffix + 1]);
          }
        }
      })
    }
  },

}
</script>
<style lang="scss" scoped>
.player-container {
  position: relative;

  .countdown,
  .liveEnd {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 75%;
    height: 65px;
    padding: 0 8px;
    box-sizing: border-box;
    background-color: #232323;
    color: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    font-size: 14px;
  }

  .countdown span {
    font-size: 20px;
    margin: 0px 3px;
    color: #901d22;
  }
}

.bg_cover {
  border-radius: 5px 5px 0 0;
  width: 100%;
  position: absolute;
  overflow: hidden;
  z-index: 99;
  // height: 130px;

  img {
    min-height: 110px;
    background-color: #fff;
    width: 100%;

  }

  ul {
    position: absolute;
    top: 0;
    bottom: 10px;
    padding: 22px;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;

    li,
    p {
      font-size: 16px;
      margin: 10px 0;
      color: #fff;
      display: flex;
      align-items: baseline;

    }

    li span {
      display: inline-block;
      width: 5px;
      height: 5px;
      background: #000;
      border-radius: 50%;
      margin-right: 5px;
      flex-shrink: 0;

    }
  }
}

.player-icon {
  width: 80px;
  height: 60px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border: 2px solid #fff;
  line-height: 74px;
  text-align: center;
  color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 30%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
}







.zimu {
  width: 100%;
  background: #232323;
  font-size: 14px;
  line-height: 1.4;
  min-height: 2.8em;
  max-height: 2.8em;
}

.textBox {
  width: 94%;
  margin: 0 3%;
  color: #fff;
  overflow: hidden;
  z-index: 10;
  display: block;
  will-change: transform;

}

@media screen and (min-width:800px) {
  .bg_cover {
    ul {
      padding: 8%;

      li,
      p {
        font-size: 20px;
      }

    }

    .player-icon {
      width: 120px;
      height: 80px;
      font-size: 46px;

    }
  }

    // .zimu {
    //   max-height: 40px !important;
    //   white-space: nowrap !important;
    //   overflow: hidden;
    //   min-height: 40px !important;
    //   line-height: 40px !important;
    // }
}

// .textBox::after {
//   content: '|';
//   position: absolute;
//   right: -5px;
//   animation: blink 0.7s infinite;
//   color: #fff;
// }

// @keyframes blink {
//   0% {
//     opacity: 0;
//   }

//   50% {
//     opacity: 1;
//   }

//   100% {
//     opacity: 0;
//   }
// }</style>



// WEBPACK FOOTER //
// src/components/Meeting/Player.vue